import { render, staticRenderFns } from "./VueDatePicker.vue?vue&type=template&id=af4c6fb4&"
import script from "./VueDatePicker.vue?vue&type=script&lang=js&"
export * from "./VueDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./VueDatePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports